import {toKSTISOString, toKSTISOStringEnd} from "../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import {createSlice} from "@reduxjs/toolkit";

const currentDate = new Date();
const initialState = {
    search: {
        searchTxt: "",
        startDate: toKSTISOString(addYears(currentDate, -1)),
        endDate: toKSTISOStringEnd(addYears(currentDate, 0)),
    },
    textSearch: {
        searchTxt: "",
    },
    pageable: {
        sort: "createdAt",
        desc: true,
        size: 10,
        totalElements: 0,
        totalPages: 0,
        page: 0,
    },
    secondarySearchText :{},
    secondaryPageable: {}
};

const searchPagingSlice = createSlice({
    name: 'searchPaging',
    initialState,
    reducers: {
        setSearch(state, action) {
            state.search = action.payload;
        },
        setTextSearch(state, action) {
            state.textSearch = action.payload;
        },
        setPageable(state, action) {
            state.pageable = action.payload;
        },
        resetPageable: (state, action) => {
            state.pageable = {
                sort: "createdAt",
                desc: true,
                size: 10,
                totalElements: 0,
                totalPages: 0,
                page: 0,
            }
        },
        setSecondaryTextSearch: (state, action) => {
            const {drawerType, searchTxt} = action.payload;
            state.secondarySearchText[drawerType] = searchTxt;
        },
        setSecondaryPageable: (state, action) => {
            const {drawerType, pageable} = action.payload;
            state.secondaryPageable[drawerType] = pageable;
        },
        resetSecondaryPageable: (state, action) => {
            const {drawerType} = action.payload;
            state.secondaryPageable[drawerType] = {
                sort: "createdAt",
                desc: true,
                size: 10,
                totalElements: 0,
                totalPages: 0,
                page: 0,
            };
        },
        resetSecondarySearchPageable: (state, action) => {
            const { drawerType } = action.payload;
            state.secondarySearchText[drawerType] = initialState.secondarySearchText[drawerType] || {
                searchTxt: "",
            };
            state.secondaryPageable[drawerType] = initialState.secondaryPageable[drawerType] || {
                sort: "createdAt",
                desc: true,
                size: 10,
                totalElements: 0,
                totalPages: 0,
                page: 0,
            };
        }
    }
});

export const {
    setSearch,
    setTextSearch,
    setPageable,
    resetPageable,
    setSecondaryTextSearch,
    setSecondaryPageable,
    resetSecondaryPageable,
    resetSecondarySearchPageable
} = searchPagingSlice.actions;
export default searchPagingSlice.reducer;